import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Loading from '~/components/Loading';

const Page = () => {
    const router = useRouter();

    const { path } = router.query || {};

    useEffect(() => {
        if (path) router.replace(path as string);
    });

    return (
        <div className="flex h-screen flex-col items-center justify-center space-y-6 text-center">
            <Loading isWithShadow={false} />
            <h1>realty.com.au</h1>
            <h2> Checking if the site connection is secure.</h2>

            <p>realty.com.au needs to review the security of your connection before proceeding.</p>
        </div>
    );
};

export default Page;
